import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Carousel from "react-bootstrap/Carousel";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import { NavLink } from "react-router-dom";
import { useHistory } from "react-router";
import { Image, Collapse } from "react-bootstrap";
import {
  ReusableMenuLink,
  ReusableMenuLinkCollapse,
} from "../../vendorDashboardComponents/navigationSection/ReusableMenuLink";
import isEmpty from "../../../store/validation/is-Empty";
import SVG from "react-inlinesvg";
import Scrollbars from "react-custom-scrollbars";

import {
  create_and_update_restaurant,
  logOutUser,
} from "../../../store/actions/authAction";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

export const SliderMobileReusableComponent = ({
  // imageOne,
  // imageTwo,
  // imageThree,
  paragraphOne,
  paragraphTwo,
  paragraphThree,
  bottomImage,
  selectedProgressBarOne,
  selectedProgressBarTwo,
  selectedProgressBarThree,
  selectedProgressBarFour,
  onLink,
  backLink,
  displayShow,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const onHamburgurClick = (e) => {
    document.getElementById("mySidenav").style.width = "340px"; //329px
  };

  const closeNav = (e) => {
    document.getElementById("mySidenav").style.width = "0";
  };

  const [state, setState] = useState({
    hasSetMapProps: false,
    openNavbar: false,
    openRestaurantDetailsMenu: false,
    openHealthAndSanitization: false,
    openFoodCategories: false,
    openBankDetails: false,
    openSubscriptions: false,
    openOtherSettings: false,
    allData: {},
  });

  const onLogoutClick = (e) => {
    e.preventDefault();
    dispatch(logOutUser());
  };

  const openRestaurantDetailsMenu = (e) => {
    setState({
      openRestaurantDetailsMenu: !state.openRestaurantDetailsMenu,
    });
  };
  const openHealthAndSanitization = (e) => {
    setState({
      openHealthAndSanitization: !state.openHealthAndSanitization,
    });
  };
  const openFoodCategories = (e) => {
    setState({
      openFoodCategories: !state.openFoodCategories,
    });
  };
  const openBankDetails = (e) => {
    setState({
      openBankDetails: !state.openBankDetails,
    });
  };
  const openSubscriptions = (e) => {
    setState({
      openSubscriptions: !state.openSubscriptions,
    });
  };
  const openOtherSettings = (e) => {
    setState({
      openOtherSettings: !state.openOtherSettings,
    });
  };

  const data = useSelector((state) => {
    return !isEmpty(state.onboarding) ? state.onboarding.restaurantDetails : "";
  });
  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  const onSuccess = (e) => {
    if (history.location.pathname === "/healthsenitation") {
      window.location.reload();
      console.log("if", history);
    } else {
      history.push("/healthsenitation");
    }
  };

  const entryPointHandler = (e) => {
    const formData = {
      selectedPage: 1,
      vendor_id: auth.VendorUser._id,
      id: data._id,
    };
    dispatch(create_and_update_restaurant(formData, onSuccess));
  };
  const insideFacilityHandler = (e) => {
    const formData = {
      selectedPage: 2,
      vendor_id: auth.VendorUser._id,
      id: data._id,
    };
    dispatch(create_and_update_restaurant(formData, onSuccess));
  };
  const employeesHandler = (e) => {
    const formData = {
      selectedPage: 3,
      vendor_id: auth.VendorUser._id,
      id: data._id,
    };
    dispatch(create_and_update_restaurant(formData, onSuccess));
  };
  const foodPreparationHandler = (e) => {
    const formData = {
      selectedPage: 4,
      vendor_id: auth.VendorUser._id,
      id: data._id,
    };
    dispatch(create_and_update_restaurant(formData, onSuccess));
  };
  const safetyHandler = (e) => {
    const formData = {
      selectedPage: 5,
      vendor_id: auth.VendorUser._id,
      id: data._id,
    };
    dispatch(create_and_update_restaurant(formData, onSuccess));
  };
  const protocolHandler = (e) => {
    const formData = {
      selectedPage: 6,
      vendor_id: auth.VendorUser._id,
      id: data._id,
    };
    dispatch(create_and_update_restaurant(formData, onSuccess));
  };

  return (
    <React.Fragment>
      <div className="d-flex align-items-center">
        {backLink && (
          <NavLink
            to={onLink}
            className="d-flex align-items-center mobile-po-left-top"
          >
            <Image
              src={require("../../../assets/images/UserManagement/left-arrow.svg")}
              alt="Back"
              width="15px"
            />
          </NavLink>
        )}
        <div className="col-12 login-section-two">
          {displayShow ? (
            <>
              <div className={`boder-hr-line-gray ${selectedProgressBarOne}`}>
                <hr />
              </div>
              <div
                className={`number-navigation-box-gray ${selectedProgressBarOne}`}
              >
                1
              </div>
              <div className={`boder-hr-line-gray ${selectedProgressBarOne}`}>
                <hr />
              </div>
              <div
                className={`number-navigation-box-gray ${selectedProgressBarTwo}`}
              >
                2
              </div>
              <div className={`boder-hr-line-gray ${selectedProgressBarTwo}`}>
                <hr />
              </div>
              <div
                className={`number-navigation-box-gray ${selectedProgressBarThree}`}
              >
                3
              </div>
              <div className={`boder-hr-line-gray ${selectedProgressBarThree}`}>
                <hr />
              </div>
              <div
                className={`number-navigation-box-gray ${selectedProgressBarFour}`}
              >
                4
              </div>
              <div className={`boder-hr-line-gray ${selectedProgressBarFour}`}>
                <hr />
              </div>
            </>
          ) : (
            <div>&nbsp;</div>
          )}
        </div>
      </div>
      <div className="row">
        <hr className="mt-0" />
        <div className="login-section-three">
          <Carousel
            className="login-screen-slider-main"
            activeIndex={index}
            onSelect={handleSelect}
          >
            <Carousel.Item className="carousel-item-slider">
              <Carousel.Caption className="slider-new-captions">
                <p>{paragraphOne}</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item className="carousel-item-slider">
              <Carousel.Caption className="slider-new-captions">
                <p>{paragraphTwo}</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item className="carousel-item-slider">
              <Carousel.Caption className="slider-new-captions">
                <p>{paragraphThree}</p>
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </div>
      </div>
      <div
        className="row position-absolute m-auto fixed-bottom"
        style={{ zIndex: "0" }}
      >
        <div className="login-section-four">
          <div className="login-screen-right-image">
            <img
              className="img-fluid"
              src={bottomImage}
              alt="Amealio"
              title="Amealio"
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
